<script setup>
import { computed } from 'vue';
import { Field } from 'vee-validate';
import { __ } from '@/utils'

defineEmits(['toggle']);

const props = defineProps({
	name: {
		type: String,
		required: true
	},
	value: {
		type: Boolean,
		default: false
	}
});

const label = computed(() => {
	if(props.value) {
		return __('active');
	}
	return __('off');
});

</script>

<template>
	<div class="toggle toggle--settings" :class="{ 'toggle--on': value }">
		<Field type="checkbox" :name="name" />
		<div class="toggle__container">
			<button type="button" class="toggle__switch" @click="$emit('toggle', !value)">
				<div class="toggle__circle"></div>
			</button>
			<div class="toggle__label">
				{{ label }}
			</div>
		</div>
	</div>
</template>